
    const original = "<svg width=\"20px\" height=\"20px\" viewBox=\"0,0,20,20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <g stroke-linecap=\"round\" stroke=\"#855CD6\" stroke-width=\"6\"><path d=\"M3,17 L17,3\"/></g>\n</svg>";

    const getSRC = () => {
        const recolored = typeof Recolor === 'object' ? (
            original.replace(/#855cd6/gi, Recolor.primary)
        ) : original;
        return 'data:image/svg+xml;,' + encodeURIComponent(recolored);
    };

    export default getSRC;
